export const PayrollIndexFields: string[] = [
    'cheque_date',
    'direct_deposit',
    'end_date',
    'late',
    'paid_at',
    'pay_date',
    'paystubs_total',
    'period_no',
    'recurring',
    'start_date',
    'state',
    'total_periods',
    'deadline',
];
